import { Create, useForm } from '@refinedev/antd';
import { Form, Input } from 'antd';
import { ILive } from 'interfaces/lives';

export const LiveCreate = () => {
  const { formProps, saveButtonProps } = useForm<ILive>({
    resource: 'prometheus/lives',
    redirect: 'show',
    action: 'create'
  });

  return (
    <Create saveButtonProps={saveButtonProps} title="Criar live">
      <Form
        {...formProps}
        layout="vertical"
        initialValues={{ recording: true }}
      >
        <Form.Item
          label="Título"
          name="title"
          rules={[
            {
              required: true
            }
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Create>
  );
};
